import React from "react";
import formatDaterange from "../../../../../../gd/format/daterange";
import formatDaterangeShort from "../../../../../../gd/format/daterange-short";
import Classes from "classnames";

type Props = {
    className   : string
    field       : any
    options     : any  // ???? It's no Option[] !!!!!
    value       : any
    disabled    : boolean

    onClick     : callback
    onChange    : callback

    children?   : any
}

export default function FieldDateRange_FormValueNotEmpty(props: Props) {

    const onDeleteClick = () => {
        props.onChange(null);
    }

    let valueFormatted

    switch (props.options?.format) {
        case 'short':
            valueFormatted  = formatDaterangeShort(props.value.start, props.value.end)

            break
        default:
            valueFormatted  = formatDaterange(props.value)
            break;
    }

    const classes = Classes("ui5-txt-default", "ui5-field-form-editable", "dropdown-form", "h-36", props.className, {
        "is-disabled": props.disabled
    })

    const valueClasses = Classes("txt-truncate", {
        "ui5-txt-default"           : !props.disabled,
        "ui5-txt-no-accent-default" : props.disabled
    })

    return (
        <>
            <div className="ui5-field-with-delete-on-hover">
                <div className={classes} onClick={props.onClick}>

                    {_.get(props.field.components, 'ValueIcon', false)}

                    <span className={valueClasses}>
                        {valueFormatted}
                    </span>
                </div>

                {props.field.clearButton && <div className="ui5-ico-trash red s-14" onClick={onDeleteClick}/>}

            </div>

            {props.children}
        </>
    );
}
